import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { PartnerMassUpdateModel } from 'Pages/pp'

export const massUpdateCuratorApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<PartnerMassUpdateModel>>(urls.company.address, {
			params,
		})
		return res.data
	},

	update: async (manager_id: number, params: { ids: string } | { manager_id: number }) => {
		const res = await axiosDS().patch<SimpleResponse>(
			urls.pp.massUpdateCurator.updateCurator,
			{ data: { manager_id } },
			{ params }
		)
		return res.data
	},
}
